import svgPaths from "../imports/svg-8njcbeg1mu";

interface SearchBarProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onLocationClick?: () => void;
}

function SearchIcon() {
  return (
    <div className="relative shrink-0 size-[14px]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 14 14">
        <g clipPath="url(#clip0_5_1918)">
          <path d={svgPaths.p37284900} className="fill-foreground" />
          <path d={svgPaths.p1e0b59b0} className="fill-foreground" />
        </g>
        <defs>
          <clipPath id="clip0_5_1918">
            <rect fill="white" height="14" width="14" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function LocationIcon() {
  return null;
}

export function SearchBar({ placeholder, value, onChange, onLocationClick: _onLocationClick }: SearchBarProps) {
  return (
    <div className="bg-background rounded-[5px] shadow-sm border border-foreground-muted/20 m-[min(5vw,1.25rem)]">
      <div className="flex items-center justify-between py-[5px] px-[20px] py-[10px]">
        <div className="content-stretch flex gap-[10px] items-center flex-1">
          <SearchIcon />
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="font-['Noto_Sans:Regular',_sans-serif] font-normal text-foreground placeholder:text-foreground-muted text-[12px] tracking-[-0.24px] bg-transparent border-none outline-none flex-1 w-full"
            style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
          />
        </div>
        <div className="shrink-0">
          <LocationIcon />
        </div>
      </div>
    </div>
  );
}